










export default
  name: 'Pager'

  props:
    pager:
      type: Object
    url:
      type: String

  methods: {
    first: () ->
      @.$router.push(@url + '1').catch((err) => )
    before: () ->
      @.$router.push(@url + (parseInt(@pager.page) - 1)).catch((err) => )
    movePage: (page) ->
      @.$router.push(@url + page).catch((err) => )
    after: () ->
      @.$router.push(@url + (parseInt(@pager.page) + 1)).catch((err) => )
    last: () ->
      @.$router.push(@url + @pager.all_page).catch((err) => )
  }
